import { LoadTender } from '@api/Trinium/Endpoints/EDI/types';

import styles from '../EdiDataGrid.module.css';

/**
 * Component to render the EDI Rejection Reasons for the DataGridPro. This componenet will only render the top 3 rejection reasons if there happen to be more than 3.
 */
export default function RejectReasonsTooltip({ row }: { row: LoadTender }) {
	if (row.ediRejectReasons.length === 0) return <>No Reason Listed</>;

	return (
		<ul className={styles['rejection-reasons-cell-content']}>
			{row.ediRejectReasons.slice(0, 3).map((rejection, index) => (
				<li
					key={`${String(row.id)}-reject-reason-${String(index)}`}
					className={styles['reject-reasons-line-item']}
				>
					{rejection.description}
				</li>
			))}
		</ul>
	);
}
